import React from 'react'

import style from './style.module.scss'
import useInterfaceLocale from '@aytm/app/swidget/base/modules/locale/useInterfaceLocale'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport'

export const SURVEY_TOOLBAR_ID = 'surveyToolbar'

export interface ISurveyToolbarProps {
  tagline?: string
  logo?: string
  preview: boolean
  secondary?: boolean
}

const SurveyToolbar = React.memo<ISurveyToolbarProps>(
  ({ tagline, logo, preview, secondary }) => {
    const { t } = useInterfaceLocale()
    const viewport = useViewport()
    const editThemePage = document.querySelector('#aytm-tool-panel')
    if (viewport.mobile) return null

    return (
      <div
        className={`${style.SurveyToolbar} ${secondary ? style.secondary : ''} ${
          editThemePage ? style.themeToolbar : ''
        }`}
        data-testid="SW-SurveyToolbar"
        id={SURVEY_TOOLBAR_ID}
      >
        {logo && <img className={style.logo} id="logo" src={logo} data-testid="SW-SurveyToolbar-Logo" />}
        {tagline && !viewport.mobile && (
          <div className={style.tagline} data-testid="SW-SurveyToolbar-Tagline">
            {tagline}
          </div>
        )}
        {(preview || editThemePage) && (
          <div className={style.rightTitle}>
            <div className={style.title} data-testid="SW-SurveyToolbar-Title">
              {t('preview', 'title')}
            </div>
            {!viewport.mobile && (
              <div className={style.subtitle} data-testid="SW-SurveyToolbar-SubTitle">
                {t('preview', 'subtitle')}
              </div>
            )}
          </div>
        )}
      </div>
    )
  },
  (prevProps, nextProps) =>
    prevProps.logo === nextProps.logo &&
    prevProps.tagline === nextProps.tagline &&
    prevProps.secondary === nextProps.secondary
)

SurveyToolbar.displayName = 'SurveyToolbar'

export default SurveyToolbar
